import HARDCODE from '../../../business-const/HardCode/HardCode'

import {
    obtemTextoArray,
} from '../../../business-components/Array/Array'

import {
    pesquisaList,
} from '../../../business-rules/List/ListService'

import {
    trataValorTexto,
} from '../cliente-form/ClienteServiceImportacao'

import {
    espaco,
    fimLinha,
    indexAtualJsonRegistros,
    obtemDadoPDF,
    jsonRegistrosInicializacao,
    jsonRegistrosJsonRegistrosInicializacao,
    jsonRegistrosJsonRegistrosAtualizaErros,
    incluiPosicaoInvestimentos,
} from './IntegracaoClienteArquivoService'



export const importaPosicaoInvestimentosSafra = (PDFTxt, idUsuarioLogado, vars, equipeList, linhaIntegracao, seguradora,
    nomeArquivo, erros, variaveisGlobais) => {

    const jsonRegistros = jsonRegistrosInicializacao()

    jsonRegistros.jsonRegistros.push(jsonRegistrosJsonRegistrosInicializacao(erros))

    const indexJsonRegistros = indexAtualJsonRegistros(jsonRegistros)

    PDFTxt = PDFTxt.replaceAll('\u0000', 'ti')
    PDFTxt = PDFTxt.replaceAll('RENDA FIXA', 'RENDA-FIXA')
    PDFTxt = PDFTxt.replaceAll('RENDA VARIÁVEL', 'RENDA-VARIÁVEL')
    PDFTxt = PDFTxt.replaceAll('CURTO PRAZO', 'CURTO-PRAZO')
    PDFTxt = PDFTxt.replaceAll('OP. ESTRUTURADAS', 'OP.-ESTRUTURADAS')
    PDFTxt = PDFTxt.replaceAll('CARTEIRA RECOMENDADA BDR', 'CARTEIRA-RECOMENDADA-BDR')
    
    //console.log(PDFTxt)



    jsonRegistros.jsonRegistros[indexJsonRegistros].instituicaoFinanceira = HARDCODE.idInstituicaoFinanceiraSafra

    
    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Agência:' + espaco, espaco,
        HARDCODE.importacaoAgencia, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, espaco + '/ Conta:' + espaco, fimLinha,
        HARDCODE.importacaoNumeroConta, true, null, erros, nomeArquivo)

    jsonRegistros.jsonRegistros[indexJsonRegistros].numeroConta =
        jsonRegistros.jsonRegistros[indexJsonRegistros].agencia + '/' +
            jsonRegistros.jsonRegistros[indexJsonRegistros].numeroConta
    
    //////obtemDadoPDFAnterior(PDFTxt, jsonRegistros, fimLinha + 'Patrimônio líquido' + fimLinha, fimLinha,
    //////    HARDCODE.importacaoPatrimonioTotalBruto, true, null, erros, nomeArquivo)

    //////obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'A rentabilidade no mês foi de' + fimLinha, fimLinha,
    //////    HARDCODE.importacaoRentabilidadeMes, true, null, erros, nomeArquivo)

    ////obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'GANHO MÊS:' + fimLinha, fimLinha,
    ////    HARDCODE.importacaoGanhoMes, true, null, erros, nomeArquivo)

    ////obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'RENTABILIDADE INÍCIO:' + fimLinha, fimLinha,
    ////    HARDCODE.importacaoRentabilidade24MesesOuDesdeInicio, false, null, erros, nomeArquivo)

    ////obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'GANHO DESDE INÍCIO:' + fimLinha, fimLinha,
    ////    HARDCODE.importacaoGanho24MesesOuDesdeInicio, false, null, erros, nomeArquivo)

    ////obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Meses Positivos' + fimLinha, fimLinha,
    ////    HARDCODE.importacaoMesesPositivos, true, null, erros, nomeArquivo)

    ////obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Meses Negativos' + fimLinha, fimLinha,
    ////    HARDCODE.importacaoMesesNegativos, true, null, erros, nomeArquivo)

    ////obtemDadoPDF(PDFTxt, jsonRegistros, /*fimLinha + 'Relatório de Investimentos */espaco + 'Data de referência:' + espaco, fimLinha,
    ////    HARDCODE.importacaoDataReferencia, true, null, erros, nomeArquivo)
    
    //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Í N D I C E S  D E  R E F E R Ê N C I A' + fimLinha +
    //    'Benchmarks Mês Atual Ano 12M 24M' + fimLinha + 'CDI' + espaco, fimLinha,
    //        HARDCODE.importacaoTaxaCDI12Meses, true, null, erros, nomeArquivo)
    
    //jsonRegistros.jsonRegistros[indexJsonRegistros].taxaCDI12Meses =
    //    trataPercentualTexto(jsonRegistros.jsonRegistros[indexJsonRegistros].taxaCDI12Meses.split(espaco)[2])
    
    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Relatório Mensal' + fimLinha + 'Posição de Investimentos' + fimLinha ,
        fimLinha + 'Investimentos Resumo Composição' + fimLinha,
            HARDCODE.importacaoPosicaoInvestimentos, true, null, erros, nomeArquivo)

    //console.log(jsonRegistros.jsonRegistros[indexJsonRegistros].posicaoInvestimentos)

    const linhasPosicaoInvestimentos =
        jsonRegistros.jsonRegistros[indexJsonRegistros].posicaoInvestimentos.split(fimLinha)
    let indexLinhasPosicaoInvestimentos

    const posicaoInvestimentos = []

    let posFinalDescricao
    let descricao
    let tipoRecursoFinanceiro
    let valor
    //let percRentabilidadeAnualRecursoFinanceiro

    let dadosPosicaoInvestimentos

    indexLinhasPosicaoInvestimentos = 0

    while (indexLinhasPosicaoInvestimentos < linhasPosicaoInvestimentos.length) {

        dadosPosicaoInvestimentos = linhasPosicaoInvestimentos[indexLinhasPosicaoInvestimentos].split(espaco)

        const tipoRecursoFinanceiroAux = pesquisaList(linhaIntegracao.tipoRecursoFinanceiro,
            dadosPosicaoInvestimentos[0]).idConversao

        if (tipoRecursoFinanceiroAux) {

            tipoRecursoFinanceiro = tipoRecursoFinanceiroAux

        } else {

            if (
                    linhasPosicaoInvestimentos[indexLinhasPosicaoInvestimentos].indexOf(',') !== - 1
            ) {
                
                posFinalDescricao = dadosPosicaoInvestimentos.length - 8

                descricao = obtemTextoArray(dadosPosicaoInvestimentos, 0, posFinalDescricao) 

                valor = trataValorTexto(dadosPosicaoInvestimentos[dadosPosicaoInvestimentos.length - 7])

                //if (dadosPosicaoInvestimentos[dadosPosicaoInvestimentos.length - 23].indexOf('-') !== -1) {

                //    valor = valor * -1
                //}

                if (valor === 0) {

                    valor = '0.00'
                }

                //Não deu certo
                //percRentabilidadeAnualRecursoFinanceiro =
                //    round(jsonRegistros.jsonRegistros[indexJsonRegistros].taxaCDI12Meses *
                //        (trataPercentualTexto(dadosPosicaoInvestimentos[10]) / 100), 2)

                //Problema com conversão de taxas negativas
                //if (dadosPosicaoInvestimentos[dadosPosicaoInvestimentos.length - 3].indexOf('/')) {

                //    percRentabilidadeAnualRecursoFinanceiro =
                //        converteTaxaMensalEmAnual(
                //            converteTaxaEmMensal(
                //                trataPercentualTexto(dadosPosicaoInvestimentos[dadosPosicaoInvestimentos.length - 2]),
                //                    calculaMeses2Datas(trataData(dadosPosicaoInvestimentos[dadosPosicaoInvestimentos.length - 3]),
                //                        somaMesesData(jsonRegistros.jsonRegistros[indexJsonRegistros].dataReferencia, -1)
                //                    )
                //            )
                //        )
                //}

                incluiPosicaoInvestimentos(posicaoInvestimentos, tipoRecursoFinanceiro, descricao,
                    valor/*, percRentabilidadeAnualRecursoFinanceiro*/,
                        jsonRegistros.jsonRegistros[indexJsonRegistros].instituicaoFinanceira,
                            null, null, null, null, null, null, null, null, null, null)
            }
        }

        indexLinhasPosicaoInvestimentos++
    }

   

    jsonRegistros.jsonRegistros[indexJsonRegistros].posicaoInvestimentos = posicaoInvestimentos
    /*
    erros.push('teste'
        .replace("$numeroProposta$", 'xxx')
            .replace("$codigoAgente$", 'yyy')
    )
    console.log(jsonRegistros)
    */



    jsonRegistrosJsonRegistrosAtualizaErros(jsonRegistros, erros)



    return jsonRegistros.jsonRegistros
}